export const validation = {
    headingMaxChar: 50,
    paragraphMaxChar: 250,
    blocks: {
      min: 1,
      max: 3
    }
  }